// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".service-name[data-v-772ec187],\n.manage-text[data-v-772ec187] {\n  color: #2d9cdb;\n}\n.entity-subtitle[data-v-772ec187] {\n  font-size: 9px;\n  color: #A6A4A6;\n}\n.expanded-item[data-v-772ec187] {\n  background: #fafafa;\n}", ""]);
// Exports
module.exports = exports;
